<template>
  <div class="timeline-warpper">
    <el-scrollbar ref="timelineScrollbar" class="default-scrollbar content-bg"
                  wrap-class="default-scrollbar__wrap" view-class="default-scrollbar__view">
      <ul style="width: 160px">
        <li class="eber-timeline-item"
            v-for="item in recordList"
            :key="item.id"
            :ref="'to_' + item.id"
            @click="currentRecord(item)">
          <div class="eber-timeline-item__content-warpper">
            <div class="eber-timeline-item__content">
              <span>{{item.admissionDate | timeformatter}}  </span>
              <span>{{item.hospitalized === 1 ? '住院' : '门诊'}}</span>
            </div>
            <div class="eber-timeline-item__diagnose"
                 v-if="item.id === record.id"
                 :title="record.diagnoseNames"
                 style="color: #1890FF">
              {{record.diagnoseNames || '无'}}
            </div>
            <div class="eber-timeline-item__diagnose" v-else :title="item.diagnoseNames">
              {{item.diagnoseNames || '无'}}
            </div>
          </div>
          <div class="eber-timeline-item__tail" style="background-color: #fff;"></div>
          <div class="eber-timeline-item__node"
               :style="{backgroundColor: item.state === 7 ? '#D9D9D9' : (item.hospitalized === 1 ? '#7ECF51' : '#2DB7F5')}">
            <div class="eber-timeline-item__node-inner"></div>
          </div>
        </li>
      </ul>
    </el-scrollbar>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import RecordService from '@/request/record/record'
  export default {
    name: "TimeLine",
    props: {
      record: {
        type: Object,
        required: true
      },
      patient: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        errmsg: null,
        recordLoading: false,
        recordList: []
      }
    },
    watch: {
      'record.id': function (){
        this.listRecord()
      }
    },
    created () {
      this.listRecord()
    },
    methods: {
      listRecord () {
        if (!this.patient) {
          this.recordList = []
          return
        }
        this.recordLoading = true
        RecordService.list({
          sort: 'admissionDate',
          order: 'desc',
          patient: this.patient
        }).then(res => {
          if (!res['result'] || _.isEmpty(res['result'])) {
            this.errmsg = '此患者没有病历'
            return
          }
          this.errmsg = null
          this.recordList = res['result'] || []
        }).catch(err => {
          if (!_.isEmpty(err)) {
            this.errmsg = err.message
          } else {
            this.errmsg = '获取患者病历列表出错'
          }
        }).finally(() => {
          this.recordLoading = false
        })
      },
      // 点击跳转
      currentRecord (record) {
        this.$emit('toRecord', record.id)
      }
    },
    filters: {
      timeformatter(time) {
        return moment(time).format('YYYY-MM-DD')
      }
    }
  }
</script>

<style scoped>
  .eber-timeline-item {
    position: relative;
    padding-bottom: 10px;
    height: 60px;
    list-style: none;
    font-size: 12px;
    cursor: pointer;
    margin-right: 10px;
  }
  .eber-timeline-item__content-warpper {
    float: right;
    z-index: 7;
    padding-right: 20px;
    text-align: right;
  }
  .eber-timeline-item__content {
    color: #999999;
    padding-bottom: 10px
  }
  .eber-timeline-item__tail {
    position: absolute;
    right: 4px;
    top: 0;
    height: 100%;
    border-left: 2px solid #e4e7ed;
    z-index: 8;
  }
  .eber-timeline-item__node {
    position: absolute;
    right: -1px;
    top: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    z-index: 8;
  }
  .eber-timeline-item__node-inner {
    position: absolute;
    width: 8px;
    height: 8px;
    top: 2px;
    right: 2px;
    border-radius: 50%;
    background-color: #fff;
  }
  .eber-timeline-item__diagnose {
    overflow: hidden;
    width: 10em;
    float: right;
    color: #666666;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>
